import ReactDOM from "react-dom";
import React from "react";
import AjaxAgenda from "./components/AjaxAgenda.jsx";

export const agendaInit = () => {
  const target = document.getElementById('workshops-list');

  if (target) {
  	ReactDOM.render(
  		<AjaxAgenda />,
  		target
  	);
  }
}
